import React, { Component } from "react";
import {
  DialogActions,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
} from "@material-ui/core";
import { getItems } from "../../../../services/inventory/itemService";
import DialogLayout from "../../../../partials/content/DialogLayout";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { formatDate } from "../../../../utils/utils";
import NumberFormat from "react-number-format";
import _ from "lodash";
import { TabView, TabPanel } from "primereact/tabview";
import withGlobalData from "../../common/withGlobalData";
class SearchItem extends Component {
  state = {
    reload: this.props.globalData.reload,
    openItemVariant: false,
    varCode: "",
    items: [],
    productionItems: [],
    sellableItems: [],
    itemPackages: [],
    asset: [],
    services: [],
    rawItem: [],
    semiFinishedItem: [],
    item: {},
    itemVarValue: [],
    varCodeList: [],
    tabs: [
      {
        ID: 1,
        title: "Sellable Items",
        icon: "fas fa-boxes",
      },
      {
        ID: 2,
        title: "Sellable Services",
        icon: "fas fa-tools",
      },
      {
        ID: 3,
        title: "Item Packages",
        icon: "fab fa-dropbox",
      },
      {
        ID: 4,
        title: "Assets",
        icon: "fas fa-building",
      },
    ],
  };
  componentDidMount() {
    this.getItems();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getItems();
      this.setState({ reload: globalData.reload });
    }
  }

  async getItems() {
    const {
      selectProductionItems = false,
      selectSellableItems = false,
      selectAssetItems = false,
      selectServiceItems = false,
      selectItemPackages = false,
      tab = 1,
    } = this.props;
    const tabsTmp = [];
    const response = await getItems();
    const { data } = response.data;
    const {
      items,
      productionItems,
      sellableItems,
      sellableService,
      asset,
      services,
      rawItem,
      semiFinishedItem,
      itemPackages,
    } = data;

    if ((selectSellableItems || selectProductionItems) && tab.ID === 1) {
      tabsTmp.push({
        ID: 1,
        title: "Sellable Items",
        icon: "fas fa-boxes",
      });
    }
    if (selectServiceItems && tab.ID === 2) {
      tabsTmp.push({
        ID: 2,
        title: "Services",
        icon: "fas fa-tools",
      });
    }
    if (selectItemPackages && tab.ID === 3) {
      tabsTmp.push({
        ID: 3,
        title: "Item Packages",
        icon: "fab fa-dropbox",
      });
    }
    if (selectAssetItems && tab.ID === 4) {
      tabsTmp.push({
        ID: 4,
        title: "Assets",
        icon: "fas fa-building",
      });
    }
    this.setState({
      items,
      tabs: tabsTmp,
      productionItems,
      sellableItems,
      sellableService,
      asset,
      services,
      rawItem,
      semiFinishedItem,
      itemPackages,
    });
  }

  render() {
    const {
      selectProductionItems = false,
      selectSellableItems = false,
    } = this.props;
    const {
      sellableItems,
      productionItems,
      services,
      itemPackages,
      asset,
      item,
      varCodeList,
      itemVarValue,
      openItemVariant,
      tabs,
    } = this.state;
    const { onSelectItem, selectVariant = false } = this.props;
    let varCodeListData = [];
    let variantList = [];
    const columns = [
      {
        field: "select",
        body: (rowData) => (
          <React.Fragment>
            <button
              type="button"
              className="btn btn-label-success btn-sm btn-pill btn-bold"
              onClick={() =>
                this.handleSelectItem(
                  rowData,
                  null,
                  varCodeListData,
                  variantList,
                  selectVariant,
                  onSelectItem
                )
              }
            >
              Select <i className="fas fa-angle-double-right"></i>
            </button>
          </React.Fragment>
        ),
      },
      {
        header: "Item ID",
        field: "ID",
        body: null,
        sortable: true,
      },
      {
        header: "Item Type",
        field: "itemTypeName",
        body: (rowData) => (
          <React.Fragment>
            <ResponsiveEllipsis text={rowData.itemTypeName} maxLine="1" />
          </React.Fragment>
        ),
        sortable: true,
      },
      {
        header: "Item Code",
        field: "itemCode",
        body: (rowData) => (
          <React.Fragment>
            <ResponsiveEllipsis text={rowData.itemCode} maxLine="1" />
          </React.Fragment>
        ),
        sortable: true,
      },
      {
        header: "Item Name",
        field: "itemName",
        body: (rowData) => (
          <React.Fragment>
            <ResponsiveEllipsis text={rowData.itemName} maxLine="1" />
          </React.Fragment>
        ),
        sortable: true,
      },
      {
        header: "Base Unit",
        field: "itemUom.uomName",
        body: null,
        sortable: true,
      },
    ];
    const itemPackagesColumns = [
      {
        field: "select",
        body: (rowData) => (
          <React.Fragment>
            <button
              type="button"
              className="btn btn-label-success btn-sm btn-pill btn-bold"
              onClick={() =>
                this.handleSelectItem(
                  null,
                  rowData,
                  varCodeListData,
                  variantList,
                  selectVariant,
                  onSelectItem
                )
              }
            >
              Select <i className="fas fa-angle-double-right"></i>
            </button>
          </React.Fragment>
        ),
      },
      {
        header: "Package ID",
        field: "ID",
        body: null,
        sortable: true,
      },
      {
        header: "Package Name",
        field: "packageName",
        body: (rowData) => (
          <React.Fragment>
            <ResponsiveEllipsis text={rowData.packageName} maxLine="1" />
          </React.Fragment>
        ),
        sortable: true,
      },
      {
        header: "Start Date",
        field: "startDate",
        body: (rowData) => formatDate(rowData.startDate),
        sortable: true,
      },
      {
        header: "End Date",
        field: "endDate",
        body: (rowData) => formatDate(rowData.endDate),
        sortable: true,
      },
      {
        header: "Currency",
        field: "currency.currencyCode",
        body: null,
        sortable: true,
        filter: true,
        hidden: true,
      },
      {
        header: "Price",
        field: "price",
        body: (rowData) => (
          <NumberFormat
            value={rowData.price}
            displayType={"text"}
            thousandSeparator={true}
            decimalScale={2}
            renderText={(value) => (
              <div className="float-right">
                {rowData.currency.currencyCode} {value}
              </div>
            )}
          />
        ),
        sortable: true,
      },
    ];
    const itemPackageDetailColumn = [
      {
        header: "Package ID",
        field: "ItemID",
        body: null,
        sortable: true,
      },
      {
        header: "Item Name",
        field: "itemName",
        body: (rowData) => (
          <React.Fragment>
            <ResponsiveEllipsis text={rowData.itemName} maxLine="1" />
          </React.Fragment>
        ),
        sortable: true,
      },
      {
        header: "Quantity",
        field: "qty",
        body: (rowData) => (
          <div>
            {rowData.qty} {rowData.uom.uomName}
          </div>
        ),
        sortable: true,
      },
      {
        header: "Unit",
        field: "uom.uomName",
        body: null,
        sortable: true,
        hidden: true,
      },
    ];
    return (
      <React.Fragment>
        <div className="tabview">
          <div className="card">
            <TabView className="tabview" scrollable>
              {tabs.map((tab, index) => (
                <TabPanel key={index} header={tab.title} rightIcon={tab.icon}>
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      {tab.ID === 1 ? (
                        <CustomDataTableSearch
                          data={
                            selectSellableItems
                              ? sellableItems
                              : selectProductionItems
                              ? productionItems
                              : null
                          }
                          onRefreshData={() => {
                            this.getItems();
                          }}
                          onSelectedData={(rowData, originalEvent) => {
                            this.handleSelectItem(
                              rowData,
                              null,
                              varCodeListData,
                              variantList,
                              selectVariant,
                              onSelectItem
                            );
                          }}
                          columns={columns}
                        />
                      ) : tab.ID === 2 ? (
                        <CustomDataTableSearch
                          data={services}
                          onRefreshData={() => {
                            this.getItems();
                          }}
                          onSelectedData={(rowData, originalEvent) => {
                            this.handleSelectItem(
                              rowData,
                              null,
                              varCodeListData,
                              variantList,
                              selectVariant,
                              onSelectItem
                            );
                          }}
                          columns={columns}
                        />
                      ) : tab.ID === 3 ? (
                        <CustomDataTableSearch
                          data={itemPackages}
                          dataDetailName="itemPackageDetails"
                          dataDetailColumns={itemPackageDetailColumn}
                          dataDetailTitle="Item Package Details"
                          onRefreshData={() => {
                            this.getItems();
                          }}
                          onSelectedData={(rowData, originalEvent) => {
                            this.handleSelectItem(
                              null,
                              rowData,
                              varCodeListData,
                              variantList,
                              selectVariant,
                              onSelectItem
                            );
                          }}
                          columns={itemPackagesColumns}
                        />
                      ) : tab.ID === 4 ? (
                        <CustomDataTableSearch
                          data={asset}
                          onRefreshData={() => {
                            this.getItems();
                          }}
                          onSelectedData={(rowData, originalEvent) => {
                            this.handleSelectItem(
                              rowData,
                              null,
                              varCodeListData,
                              variantList,
                              selectVariant,
                              onSelectItem
                            );
                          }}
                          columns={columns}
                        />
                      ) : null}
                    </div>
                  </div>
                </TabPanel>
              ))}
            </TabView>
          </div>
        </div>
        <DialogLayout
          open={openItemVariant}
          title={`Select Variant Item ${item.itemName}`}
          onCloseDialog={this.handleCloseSelectVariant}
          maxWIdth="sm"
        >
          {varCodeList.map((variant, index) => (
            <FormControl
              key={variant.varID}
              variant="outlined"
              size="small"
              margin="normal"
              fullWidth={true}
            >
              <InputLabel id={`variant-${variant.varID}`}>
                {variant.varName}
              </InputLabel>
              <Select
                name={`variant-${variant.varID}`}
                label={variant.varName}
                value={variant.value}
                onChange={(e) => this.handleSelectVariantValue(e, index)}
              >
                <MenuItem value="0">Select Variant</MenuItem>
                {itemVarValue.map((varValue) =>
                  variant.varID === varValue.varID ? (
                    <MenuItem key={varValue.ID} value={varValue.ID}>
                      {varValue.varValue}
                    </MenuItem>
                  ) : null
                )}
              </Select>
            </FormControl>
          ))}
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={() => this.handleCloseSelectVariant(item)}
            >
              <i className="fas fa-window-close"></i>
              Close
            </button>
            <button
              type="button"
              className="btn btn-primary btn-md btn-pill btn-bold"
              onClick={this.handleSelectVariant}
            >
              <i className="fas fa-mouse-pointer"></i>
              Select
            </button>
          </DialogActions>
        </DialogLayout>
      </React.Fragment>
    );
  }

  handleSelectItem = (
    item,
    itemPackage,
    varCodeListData = [],
    variantList = [],
    selectVariant,
    onSelectItem
  ) => {
    if (item !== null) {
      if (item.itemVarValue.length > 0 && selectVariant) {
        variantList = _.uniqBy(item.itemVarValue, "varID");
        variantList.forEach((variant) => {
          varCodeListData.push({
            varID: variant.varID,
            varName: variant.itemVariant.varName,
            value: "",
            valueName: "",
          });
        });
        this.setState({
          item,
          varCodeList: varCodeListData,
          itemVarValue: item.itemVarValue,
          openItemVariant: true,
        });
      } else {
        onSelectItem(item, null, "", "");
      }
    } else if (itemPackage !== null) {
      onSelectItem(null, itemPackage, "", "");
    }
  };

  handleCloseSelectVariant = () => {
    this.setState({ openItemVariant: false });
  };

  handleSelectVariant = () => {
    const { item, varCodeList } = this.state;
    const { onSelectItem } = this.props;
    const totalLength = varCodeList.length - 1;
    let error = false;
    let varCode = "";
    let valueName = "";
    varCodeList.forEach((variant, index) => {
      if (variant.value !== "") {
        varCode += `${variant.varID}=${variant.value}`;
        valueName += variant.varName + " = " + variant.valueName;
        if (totalLength !== index) {
          varCode += "+";
          valueName += " ";
        }
      } else {
        error = true;
      }
    });
    if (!error) {
      onSelectItem(item, null, varCode, valueName);
    }
  };

  handleSelectVariantValue = (e, index) => {
    const { varCodeList, itemVarValue } = this.state;

    const valueSelected = _.find(itemVarValue, ["ID", e.target.value]);
    if (valueSelected) {
      const varCodeListClone = [...varCodeList];
      varCodeListClone[index].value = e.target.value;
      varCodeListClone[index].valueName = valueSelected.varValue;
      this.setState({ varCodeList: varCodeListClone });
    }
  };
}

export default withGlobalData(SearchItem);
